import { Contact, Layout } from '@rumblefish/ui/Rumblefish23Theme';
import { useRef } from 'react';

import { NextHeadWithMeta } from '../NextHeadWithMeta';
import { Benefits } from './Benefits';
import { dedicatedDevTeamsSeo } from './DedicatedDevTeams.seo';
import type { DedicatedDevTeamsProps } from './DedicatedDevTeams.types';
import { DedicatedTeamService } from './DedicatedTeamService';
import { Faq } from './Faq';
import { Hero } from './Hero';

export const DedicatedDevTeams = ({ blogPosts }: DedicatedDevTeamsProps) => {
  const offerRef = useRef<HTMLDivElement>(null);
  return (
    <Layout blogPosts={blogPosts}>
      <NextHeadWithMeta {...dedicatedDevTeamsSeo} />
      <Hero />
      <DedicatedTeamService offerRef={offerRef} />

      <Benefits />
      <Faq />
      <Contact
        subtitle="We will answer any questions you may have related to Dedicated Development Teams!"
        color="red"
      />
    </Layout>
  );
};
